<template>
  <div id="app">
    <Top :shift='topFixed' />
    <div class="container" id="loadingBox" :style="{'padding-top':topFixed?'70px':'0'}">
      <router-view/>
    </div>
    <Foot v-if="$route.meta.isFoot" />
  </div>
</template>

<script>
import Top from './components/top.vue'
import Foot from './components/foot.vue'
export default {
  name: 'App',
  components:{Foot,Top},
  data () {
    return {
      topFixed:false,
    }
  },
  mounted(){
    var that=this;
    window.addEventListener('scroll', function () {
      var scrollTop = document.documentElement.scrollTop || document.body.scrollTop
      var htmlAllHeight=document.body.scrollHeight;
      
      if (scrollTop>170) {// 顶部固定
        if(htmlAllHeight-170>1200){
          that.topFixed=true;
        }
      }else{
        that.topFixed=false;
      }
    })
    // 给页面设置一个 最小高度 window.screen.height
    // const allHeight=window.screen.availHeight;
    // document.getElementById('loadingBox').style.minHeight='740px';
    // document.getElementById('loadingBox').style.minHeight=(allHeight-270)+'px';
  }
}
</script>

<style lang="less">
html,body{
  width: 100%;
  min-height: 100vh;
}
#app{
  min-height: 100vh;
}
 .container{background: #fff;min-height: calc(100vh - 70px);}
 p{img{max-width: 100% !important;}}
</style>



// WEBPACK FOOTER //
// src/App.vue